import { useMutation } from 'react-query';

import setupIntents from 'api/payment/setupIntents';

const useSetupIntents = () => {
  return useMutation(setupIntents);
};

export default useSetupIntents;
